var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_6616",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_6616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24365 13.6667L7.99999 2L14.7563 13.6667H1.24365ZM2.96665 12.6667H13.0333L7.99999 4L2.96665 12.6667ZM7.99999 11.8718C8.15254 11.8718 8.28043 11.8202 8.38365 11.717C8.48687 11.6138 8.53849 11.4859 8.53849 11.3333C8.53849 11.1808 8.48687 11.0529 8.38365 10.9497C8.28043 10.8464 8.15254 10.7948 7.99999 10.7948C7.84743 10.7948 7.71954 10.8464 7.61632 10.9497C7.5131 11.0529 7.46149 11.1808 7.46149 11.3333C7.46149 11.4859 7.5131 11.6138 7.61632 11.717C7.71954 11.8202 7.84743 11.8718 7.99999 11.8718ZM7.49999 10.1282H8.49999V6.79483H7.49999V10.1282Z",
    fill: "#495054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpact);
export default __webpack_public_path__ + "static/media/impact.9a13f7b841319df82bb7f67d360165bb.svg";
export { ForwardRef as ReactComponent };